import axios from "axios";
import { API } from "../config";
import { xhrCall } from "../utils/Constants";
// import { isLocalHost } from "../utils/Utils";
const baseURL = API;


export const AxiosInstancePrivate = () => {
    const axiosIns = axios.create({
        baseURL: `${baseURL}/admin`,
        //  withCredentials: true
    });

    axiosIns.interceptors.request.use(
        (config) => {
            config.headers['Authorization'] = sessionStorage.getItem('idToken');
            // if (isLocalHost) {
            //     config.headers.Authorization = sessionStorage.getItem('userToken');
            //     config.headers['pr-admin-authorize'] = sessionStorage.getItem('idToken');
            // } else {
            //     config.headers['pr-admin-authorize'] = sessionStorage.getItem('idToken');
            // }
            const restIdleTimeTracker = new CustomEvent(xhrCall, { detail: config.url });
            window.dispatchEvent(restIdleTimeTracker);
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    axiosIns.interceptors.response.use(
        (res) => {
            return res;
        },
        async function (error) {
            return Promise.reject(error)
        }
    );

    return axiosIns;
};
